var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM13.5805 7.97493C13.8428 7.65434 13.7955 7.18183 13.4749 6.91953C13.1543 6.65724 12.6818 6.70449 12.4195 7.02507L8.44432 11.8837L7.03033 10.4697C6.73744 10.1768 6.26256 10.1768 5.96967 10.4697C5.67678 10.7626 5.67678 11.2374 5.96967 11.5303L7.96967 13.5303C8.1195 13.6802 8.32573 13.7596 8.53736 13.7491C8.74899 13.7385 8.94629 13.6389 9.08047 13.4749L13.5805 7.97493Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheck);
export default __webpack_public_path__ + "static/media/orange-check.0843374bd9a3653fffb57cdace63d5ae.svg";
export { ForwardRef as ReactComponent };